// Google Analytics Tracking ID
// https://github.com/truethari/reactfolio#-google-analytics
export const TRACKING_ID = "G-P9F4DFLB65";
